import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseUUIDEntity from "./BaseUUIDEntity";

@inheritSerialization(BaseUUIDEntity)
export default class Pendaftar extends BaseUUIDEntity {

    @serialize
    @deserialize
    public nomor: string = "";

    @serialize
    @deserialize
    public nama_lengkap: string = "";

    @serialize
    @deserialize
    public jenis_kelamin: string = "";

    @serialize
    @deserialize
    public tahun: string = "";

    @serialize
    @deserialize
    public lulusan: string = "";

    @serialize
    @deserialize
    public pendidikan_formal: string = "";

    @serialize
    @deserialize
    public pendidikan_non_formal: string = "";

    @serialize
    @deserialize
    public virtual_account: string = "";

    @serialize
    @deserialize
    public proses: string = "";

    @serialize
    @deserialize
    public status_pembayaran: string = "";

    @serialize
    @deserialize
    public status_formulir: string = "";

    @serialize
    @deserialize
    public orang_tua: string = "";

}
